import { ActionBase } from '../../../core/store/action/ActionBase';

export const ACTIVATE_DRAFT_DISCLAIMER_DESCRIPTION_ACTION = '[Configuration] Messages Activate Draft Disclaimer Description';

export class ActivateDraftDisclaimerDescriptionAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ACTIVATE_DRAFT_DISCLAIMER_DESCRIPTION_ACTION;
}



// WEBPACK FOOTER //
// ./src/app/messages/store/actions/ActivateDraftDisclaimerDescriptionAction.ts